/**
 * 活动接口部分, jackery life / earth day
 * 创建者: garfield
 * 创建日期: 2023-04-18
 */

import { get } from './http';

// 地球日微章信息和展示接口查询
export const earthDayInfo = (params) => {
  return get(`/account/accountProfileAction/findEarthdayPic`, {params});
}

// jackery life站内信和跳转信息
export const jackeryLifeInfo = (params) => {
  return get(`/account/accountProfileAction/findJackeryLifeInfo`, {params});
}
